export default __webpack_public_path__ + "static/media/image07.2d206550.jpg";